/* eslint-disable angular/document-service */
import PropTypes from 'prop-types';
import React, {
    useState, useCallback, useEffect, useRef,
} from 'react';

export default function DatePicker({ isLoaded }) {
    const today = new Date().toISOString().split('T')[0];
    const [selectedDate, setSelectedDate] = useState(today);
    const [disabled, setDisabled] = useState(isLoaded);
    useEffect(() => {
        setDisabled(isLoaded);
    }, [isLoaded]);
    const handleDateChange = useCallback(
        (event) => {
            setSelectedDate(event.target.value);
        },
        [selectedDate],
    );
    const dateRef = useRef();
    const handleDateClick = () => {
        dateRef.current.showPicker();
    };

    return (
        <div onClick={handleDateClick}>
            <input
                id='personal-video-date'
                type='date'
                disabled={disabled}
                data-testid='personal-video-date'
                max={today}
                ref={dateRef}
                value={selectedDate}
                className='tv-text-input-date'
                onChange={handleDateChange}
            />
        </div>
    );
}

DatePicker.propTypes = {
    isLoaded: PropTypes.bool,
};
